// CfdPagination.jsx
import React from "react";
import PropTypes from "prop-types";
import "./CfdPagination.css";
import { trackButtonClick } from "@/utils/analytics";

const CfdPagination = ({ currentPage, totalPages, setCurrentPage }) => {
  return (
    <div className="cfd-pagination">
      <ul className="cfd-pagination-list">
        {/* Previous Button */}
        <li
          className={`cfd-pagination-item ${
            currentPage === 1 ? "disabled" : ""
          }`}
        >
          <button
            className="cfd-pagination-link prev-next-btn"
            onClick={() => {
              const targetPage = Math.max(currentPage - 1, 1);
              setCurrentPage(targetPage);
              trackButtonClick({
                eventName: "cfd_all_list_previous_page_click",
                eventCategory: "CFD dashboard",
                eventSource: "on previous page click",
                eventLabel: `Current Page: ${currentPage} | Page clicked: ${targetPage} | Section: CFD`,
              });
            }}
            disabled={currentPage === 1}
            aria-label="Previous page"
          >
            <span className="fa fa-angle-left"></span>
          </button>
        </li>

        {/* Page Numbers */}
        {[...Array(totalPages)].map((_, index) => (
          <li
            key={index}
            className={`cfd-pagination-item ${
              currentPage === index + 1 ? "active" : ""
            }`}
          >
            <button
              className="cfd-pagination-link"
              onClick={() => {
                setCurrentPage(index + 1);
                trackButtonClick({
                  eventName: "cfd_all_list_page_number_click",
                  eventCategory: "CFD dashboard",
                  eventSource: "on page number click",
                  eventLabel: `Current Page: ${currentPage} | Page clicked: ${
                    index + 1
                  } | Section: CFD`,
                });
              }}
              aria-label={`Page ${index + 1}`}
            >
              {index + 1}
            </button>
          </li>
        ))}

        {/* Next Button */}
        <li
          className={`cfd-pagination-item ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        >
          <button
            className="cfd-pagination-link cfd-prev-next-btn"
            onClick={() => {
              const targetPage = Math.min(currentPage + 1, totalPages);
              setCurrentPage(targetPage);
              trackButtonClick({
                eventName: "cfd_all_list_next_page_click",
                eventCategory: "CFD dashboard",
                eventSource: "on next page click",
                eventLabel: `Current Page: ${currentPage} | Page clicked: ${targetPage} | Section: CFD`,
              });
            }}
            disabled={currentPage === totalPages}
            aria-label="Next page"
          >
            <span className="fa fa-angle-right"></span>
          </button>
        </li>
      </ul>
    </div>
  );
};

CfdPagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
};

export default CfdPagination;
